<div class="w-full flex flex-col gap-y-2">
  <app-candidate-dashboard [fromEmployerView]="true" [employeeId]="employeeId">
    <app-buttons
      [iconPos]="'left'"
      icon="pi pi-arrow-left"
      (click)="goBack()"
      (keydown.enter)="goBack()"
      [btnClass]="BUTTON_CLASS_TYPES.TERTIARY"
      [aria-label]="'button_labels.back_to_employees' | translate"
    >
    </app-buttons>
  </app-candidate-dashboard>
</div>